<template>
  <div class="header-page">
    <div @click="toPath(1)" :class="navIndex == 1 ? 'oneys' : 'one'">
      可视化驾驶舱
    </div>
    <div @click="toPath(2)" :class="navIndex == 2 ? 'twoys' : 'two'">
      智慧养鸡基地
    </div>
    <div @click="toPath(3)" :class="navIndex == 3 ? 'threeys' : 'three'">
      智能设备监测
    </div>
    <!-- 中间标题 -->
    <p class="header-page-title">{{ title }}</p>
    <div @click="toPath(4)" :class="navIndex == 4 ? 'fileys' : 'file'">
      销售经济数据分析
    </div>
    <div @click="toPath(5)" :class="navIndex == 5 ? 'fitys' : 'fit'">
      产品溯源
    </div>
    <!-- 天气 -->
    <div>
      <!-- 天气 -->
      <div class="header-page-right">
        <div class="header-right-tq">
          <img
            v-if="tqinconNum == 0"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/0.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 1"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/1.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 2"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/2.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 3"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/3.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 4"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/4.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 6"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/6.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 7"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/7.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 8"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/8.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 9"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/9.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 13"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/13.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 14"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/14.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 15"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/15.png"
            alt=""
          />
          <img
            v-if="tqinconNum == 16"
            style="width: 25px; height: 25px"
            src="../assets/tianqi/pngbai/16.png"
            alt=""
          />
          <span style="padding: 0 10px">{{ weather }}</span>
          <span>{{ maxweat }}℃~{{ minweat }}℃</span>
        </div>
        <!-- <div class="header-right-adree">
          <img
            src="../assets/daohang.png"
            style="width: 16px; height: 20px; margin-right: 3px"
            alt=""
          />
          <h5>常德市</h5>
        </div> -->
      </div>
      <!-- 日期 -->
      <div class="header-page-data">
        <p>{{ dateTime.replace(/\//g, "-") }}</p>
        <p style="padding: 0 10px">{{ week[weekday - 1] }}</p>
        <p>{{ time }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["title", "navIndex"],
  components: {},
  data() {
    return {
      // 天气
      weather: "晴",
      // 最高温度
      maxweat: "30",
      // 最低温度
      minweat: "20",
      // 显示那个天气图片
      tqinconNum: 0,
      // 当前日期
      dateTime: "2024/5/22",
      // 星期几
      weekday: "2",
      week: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日",
      ],
      // 当前时间
      time: "18:02:21",
    };
  },
  created() {
    this.tq();
    // 获取当前日期
    this.dateTime = new Date().toLocaleDateString();
    // 获取当前星期
    this.weekday = new Date().getDay();
    // 获取当前时间
    this.time = new Date().toLocaleTimeString();
    // 获取天气
    let tianqi = JSON.parse(localStorage.getItem("tq"));
    this.weather = tianqi.detail[0].day.weather.info;
    this.maxweat = tianqi.detail[0].day.weather.temperature;
    this.minweat = tianqi.detail[0].night.weather.temperature;
    this.tqinconNum = tianqi.detail[0].day.weather.img;
  },
  mounted() {
    document.title = this.title;
    // 时间实时变化
    this.interval = setInterval(() => {
      this.time = new Date().toLocaleTimeString();
    }, 1000);
  },
  beforeDestroy() {
    // 在组件卸载时清除定时器
    clearInterval(this.interval);
  },
  methods: {
    // 获取天气
    tq() {
      axios({
        method: "get",
        url: "http://www.nmc.cn/rest/weather?stationid=YVItN&_=1720752892716",
      }).then((res) => {
        if (res.data.data.predict.detail[0].day.weather.temperature != 9999) {
          localStorage.setItem("tq", JSON.stringify(res.data.data.predict));
          localStorage.setItem("tqyujing", JSON.stringify(res.data.data.real));
        }
      });
    },
    // nav跳转
    toPath(val) {
      this.navIndex = val;
      if (val == 1) {
        this.$router.push("/cockpit");
      } else if (val == 2) {
        this.$router.push("/base");
      } else if (val == 3) {
        this.$router.push("/device");
      } else if (val == 4) {
        this.$router.push("/price");
      } else if (val == 5) {
        this.$router.push("/suyuan");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header-page {
  box-sizing: border-box;
  height: 70px;
  line-height: 70px;
  background: url(~@/assets/header-title.png) no-repeat center center;
  background-size: 100% auto;
  border: 1px solid transparent;
  position: relative;
  margin-bottom: 20px;
}
.header-page-data {
  position: absolute;
  right: 10px;
  top: 15px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
}
.header-page-title {
  font-size: 32px;
  color: white;
  text-align: center;
  font-weight: bold;
  letter-spacing: 3px;
}
.header-page-right {
  position: absolute;
  right: 10px;
  top: -15px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
}
.header-right-tq {
  display: flex;
  align-items: center;
  // padding-right: 10px;
}
.header-right-adree {
  display: flex;
  align-items: center;
  //   position: absolute;
  //   right: 5px;
  //   top: 15px;
  //   h5{
  // font-size: 20px;
  //   }
}
h5 {
  color: #fff !important;
  font-weight: 800;
  margin-top: 5px;
  /* font-size: 16px; */
}
.navigation-box {
  display: flex;
  justify-content: flex-start;
  height: 60px;
  border: 1px solid transparent;
  position: absolute;
  top: 54px;
  left: 20px;
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.navigation-item {
  width: 100px;
  height: 40px;
  line-height: 36px;
  border: 2px solid #1c6dd0;
  border-radius: 5px;
  margin-right: 10px;
  cursor: pointer;
  text-align: center;
}
.navigation-box .active {
  background-color: #1c6dd0;
}
.one {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  left: 10px;
  background: url(~@/assets/leftblue.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing: 3px;
}
.oneys {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  left: 10px;
  background: url(~@/assets/leftyelly.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing: 2px;
}
.two {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  left: 190px;
  // left: 10px;
  background: url(~@/assets/leftblue.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing: 2px;
}
.twoys {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  left: 190px;
  // left: 10px;
  background: url(~@/assets/leftyelly.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing: 2px;
}
.three {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  left: 370px;
  // left: 260px;
  background: url(~@/assets/leftblue.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing: 2px;
}
.threeys {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  left: 370px;
  // left: 260px;
  background: url(~@/assets/leftyelly.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing: 2px;
}
.file {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  right: 370px;
  background: url(~@/assets/rightblue.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing:1px;
}
.fileys {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  right: 370px;
  background: url(~@/assets/rightyelly.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing: 1px;
}
.fit {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  right: 190px;
  background: url(~@/assets/rightblue.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing: 3px;
}
.fitys {
  color: #fff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  font-size: 18px;
  width: 200px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  right: 190px;
  background: url(~@/assets/rightyelly.png) no-repeat center center;
  background-size: 100% 100%;
  font-weight: 600;
  letter-spacing: 3px;
}
</style>
